import React 		from 'react'
import classnames 	from 'classnames'
import renderHTML 	from 'react-render-html'

import ARYImage 	from '../ary-image'
import {
	TextBlock
} from '../text-block'

import {
	formatImageForARYImage
} from '../../lib/_helpers'

class TextBlockQuote extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			quote,
			person,
			position,
			image,
			color,
			display,
			indent,
			small
		} = this.props

		const displayAlt = display === 'rule'

		return <TextBlock
			className={ classnames({
				[`textBlock--quote-c--${ color }`]: !!color,
				'textBlock--quote-alt': displayAlt,
				'textBlock--quote-alt-indent': displayAlt && indent,
				'textBlock--quote-small': small
			}) }
			type="quote">
			{ quote ? <p className="p--quote">
				{ !displayAlt ? <span className="p--quote-mark p--quote-mark--start" /> : null }
				{ renderHTML(quote) }
				{ !displayAlt ? <span className="p--quote-mark p--quote-mark--end" /> : null }
			</p> : null }
			{ person || position || image ? <div className="quote-detail">
				{ image ? <div className="quote-image">
					<ARYImage
						image={ formatImageForARYImage(image) }
						/>
				</div> : null }
				{ person || position ? <div className="quote-detail-detail">
					{ person ? <div className="quote-person">{ person }</div> : null }
					{ position ? <div className="quote-position">{ position }</div> : null }
				</div> : null }
			</div> : null }
		</TextBlock>
	}
}

export default TextBlockQuote